import { fetchApi } from "../../tools";

const callCiclo = async (url, headers) => {
  const data = await fetchApi({
    url: `${url}/utils/busquedas`,
    headers: headers,
    content: {
      opcion: "CICLO_ACTUAL",
    },
  });
  return data[0].Ciclo;
};

const getSedes = async (url, headers) => {
  const response = await fetchApi({
      url: `${url}/utils/busquedas`,
      headers: headers,
      content: {
          Opcion: "SEDES"
      }
  })
 return response.msg
}

const getPlanes = async (url, headers) => {
    const planes = await fetchApi({
        url: `${url}/utils/busquedas`,
        headers: headers,
        content: {
            "Opcion": "PLANES"
          }
    });
  return planes.msg;
}

const getHorarios = async (url, headers, plan) => {
    const horarios = await fetchApi({
        url:`${url}/utils/busquedas`,
        headers: headers,
        content:{
          "Opcion": "CAT_HORARIOS",
          "IdPlan": plan
        }
    });
  return horarios.msg;
}

const getCursos = async (url, headers, mes, ciclo, sede) => {
    const cursos = await fetchApi({
        url:`${url}/utils/busquedas`,
        headers: headers,
        content: {
          "Opcion": "CURSOS_APERTURADOS",
          "Mes": mes,
          "IdCiclo": ciclo,
          "IdSede": sede
        }
    });
  return cursos.msg;
}

export { 
    getPlanes,
    getSedes,
    getCursos,
    callCiclo,
    getHorarios,
 };